export default __webpack_public_path__ + "static/media/151-banker.54b3f723.png";